/** Holding / Unholding of a variety, party or order. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { HoldsPage } from "@/features/sales-dispatch/components/holds-page";

export const Route = createFileRoute("/_app/orders/holds")({
  beforeLoad: () => {
    if (!useAuth.getState().can("orders.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return <HoldsPage facilityId={selected?.id} />;
}
